import { Injectable, NgZone } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { grpc } from '@improbable-eng/grpc-web';

import {
  MingaSmsDetails,
  SmsMingaGetDetailsRequest,
  SmsAdminAddMessageBlockRequest,
  SmsAdminGetDetailsRequest,
  SmsAdminSetMaxSendCountRequest,
} from '../sms/sms_pb';

import {
  SmsMinga as __SmsMinga,
  SmsAdmin as __SmsAdmin,
} from '../sms/sms_pb_service';

/**
  / Service related to SMS for the current minga only
  */
@Injectable({providedIn: 'root'})
export class SmsMinga {

  constructor(private _ngZone: NgZone) {
  }

  getDetails(request: SmsMingaGetDetailsRequest): Promise<MingaSmsDetails>;
  getDetails(request: SmsMingaGetDetailsRequest, metadata: grpc.Metadata): Promise<MingaSmsDetails>;
  getDetails(request: SmsMingaGetDetailsRequest, callback: (err: any|null, response: MingaSmsDetails, metadata: grpc.Metadata) => void): void;
  getDetails(request: SmsMingaGetDetailsRequest, metadata: grpc.Metadata, callback: (err: any|null, response: MingaSmsDetails, metadata: grpc.Metadata) => void): void;

  getDetails(request: SmsMingaGetDetailsRequest, arg1?: grpc.Metadata|((err: any|null, response: MingaSmsDetails, metadata: grpc.Metadata) => void), arg2?: (err: any|null, response: MingaSmsDetails, metadata: grpc.Metadata) => void): Promise<MingaSmsDetails>|void {
    let ret: any;
    let callback: any;
    let metadata: any;

    if(typeof arg1 === 'function') {
      callback = arg1;
    } else {
      metadata = arg1;
      callback = arg2;
    }

    if(!callback) {
      ret = new Promise<MingaSmsDetails>((resolve, reject) => {
        callback = (err: any, response: any) => {
          if(err) reject(err);
          else resolve(response);
        };
      });
    }

    let responseMetadata: grpc.Metadata|null = null;

    let req = grpc.invoke(__SmsMinga.GetDetails, {
      request: request,
      host: (<any>window).DEFAULT_ANGULAR_GRPC_HOST || 'https://' + location.hostname,
      metadata: metadata,
      onHeaders: headers => responseMetadata = headers,
      onMessage: response => this._ngZone.run(() => {
        callback(null, response, responseMetadata || new grpc.Metadata());
      }),
      onEnd: (code, msg, metadata) => this._ngZone.run(() => {
        if(code != grpc.Code.OK) {
          let err = new Error(msg);
          (<any>err).code = code;
          callback(err);
        }
      })
    });

    (<any>ret).cancel = () => req.close();
    return ret;
  }

}


/**
  / Service related to admin SMS management for all mingas
  */
@Injectable({providedIn: 'root'})
export class SmsAdmin {

  constructor(private _ngZone: NgZone) {
  }

  getDetails(request: SmsAdminGetDetailsRequest): Promise<MingaSmsDetails>;
  getDetails(request: SmsAdminGetDetailsRequest, metadata: grpc.Metadata): Promise<MingaSmsDetails>;
  getDetails(request: SmsAdminGetDetailsRequest, callback: (err: any|null, response: MingaSmsDetails, metadata: grpc.Metadata) => void): void;
  getDetails(request: SmsAdminGetDetailsRequest, metadata: grpc.Metadata, callback: (err: any|null, response: MingaSmsDetails, metadata: grpc.Metadata) => void): void;

  getDetails(request: SmsAdminGetDetailsRequest, arg1?: grpc.Metadata|((err: any|null, response: MingaSmsDetails, metadata: grpc.Metadata) => void), arg2?: (err: any|null, response: MingaSmsDetails, metadata: grpc.Metadata) => void): Promise<MingaSmsDetails>|void {
    let ret: any;
    let callback: any;
    let metadata: any;

    if(typeof arg1 === 'function') {
      callback = arg1;
    } else {
      metadata = arg1;
      callback = arg2;
    }

    if(!callback) {
      ret = new Promise<MingaSmsDetails>((resolve, reject) => {
        callback = (err: any, response: any) => {
          if(err) reject(err);
          else resolve(response);
        };
      });
    }

    let responseMetadata: grpc.Metadata|null = null;

    let req = grpc.invoke(__SmsAdmin.GetDetails, {
      request: request,
      host: (<any>window).DEFAULT_ANGULAR_GRPC_HOST || 'https://' + location.hostname,
      metadata: metadata,
      onHeaders: headers => responseMetadata = headers,
      onMessage: response => this._ngZone.run(() => {
        callback(null, response, responseMetadata || new grpc.Metadata());
      }),
      onEnd: (code, msg, metadata) => this._ngZone.run(() => {
        if(code != grpc.Code.OK) {
          let err = new Error(msg);
          (<any>err).code = code;
          callback(err);
        }
      })
    });

    (<any>ret).cancel = () => req.close();
    return ret;
  }

  setMaxSendCount(request: SmsAdminSetMaxSendCountRequest): Promise<MingaSmsDetails>;
  setMaxSendCount(request: SmsAdminSetMaxSendCountRequest, metadata: grpc.Metadata): Promise<MingaSmsDetails>;
  setMaxSendCount(request: SmsAdminSetMaxSendCountRequest, callback: (err: any|null, response: MingaSmsDetails, metadata: grpc.Metadata) => void): void;
  setMaxSendCount(request: SmsAdminSetMaxSendCountRequest, metadata: grpc.Metadata, callback: (err: any|null, response: MingaSmsDetails, metadata: grpc.Metadata) => void): void;

  setMaxSendCount(request: SmsAdminSetMaxSendCountRequest, arg1?: grpc.Metadata|((err: any|null, response: MingaSmsDetails, metadata: grpc.Metadata) => void), arg2?: (err: any|null, response: MingaSmsDetails, metadata: grpc.Metadata) => void): Promise<MingaSmsDetails>|void {
    let ret: any;
    let callback: any;
    let metadata: any;

    if(typeof arg1 === 'function') {
      callback = arg1;
    } else {
      metadata = arg1;
      callback = arg2;
    }

    if(!callback) {
      ret = new Promise<MingaSmsDetails>((resolve, reject) => {
        callback = (err: any, response: any) => {
          if(err) reject(err);
          else resolve(response);
        };
      });
    }

    let responseMetadata: grpc.Metadata|null = null;

    let req = grpc.invoke(__SmsAdmin.SetMaxSendCount, {
      request: request,
      host: (<any>window).DEFAULT_ANGULAR_GRPC_HOST || 'https://' + location.hostname,
      metadata: metadata,
      onHeaders: headers => responseMetadata = headers,
      onMessage: response => this._ngZone.run(() => {
        callback(null, response, responseMetadata || new grpc.Metadata());
      }),
      onEnd: (code, msg, metadata) => this._ngZone.run(() => {
        if(code != grpc.Code.OK) {
          let err = new Error(msg);
          (<any>err).code = code;
          callback(err);
        }
      })
    });

    (<any>ret).cancel = () => req.close();
    return ret;
  }

  addMessageBlock(request: SmsAdminAddMessageBlockRequest): Promise<MingaSmsDetails>;
  addMessageBlock(request: SmsAdminAddMessageBlockRequest, metadata: grpc.Metadata): Promise<MingaSmsDetails>;
  addMessageBlock(request: SmsAdminAddMessageBlockRequest, callback: (err: any|null, response: MingaSmsDetails, metadata: grpc.Metadata) => void): void;
  addMessageBlock(request: SmsAdminAddMessageBlockRequest, metadata: grpc.Metadata, callback: (err: any|null, response: MingaSmsDetails, metadata: grpc.Metadata) => void): void;

  addMessageBlock(request: SmsAdminAddMessageBlockRequest, arg1?: grpc.Metadata|((err: any|null, response: MingaSmsDetails, metadata: grpc.Metadata) => void), arg2?: (err: any|null, response: MingaSmsDetails, metadata: grpc.Metadata) => void): Promise<MingaSmsDetails>|void {
    let ret: any;
    let callback: any;
    let metadata: any;

    if(typeof arg1 === 'function') {
      callback = arg1;
    } else {
      metadata = arg1;
      callback = arg2;
    }

    if(!callback) {
      ret = new Promise<MingaSmsDetails>((resolve, reject) => {
        callback = (err: any, response: any) => {
          if(err) reject(err);
          else resolve(response);
        };
      });
    }

    let responseMetadata: grpc.Metadata|null = null;

    let req = grpc.invoke(__SmsAdmin.AddMessageBlock, {
      request: request,
      host: (<any>window).DEFAULT_ANGULAR_GRPC_HOST || 'https://' + location.hostname,
      metadata: metadata,
      onHeaders: headers => responseMetadata = headers,
      onMessage: response => this._ngZone.run(() => {
        callback(null, response, responseMetadata || new grpc.Metadata());
      }),
      onEnd: (code, msg, metadata) => this._ngZone.run(() => {
        if(code != grpc.Code.OK) {
          let err = new Error(msg);
          (<any>err).code = code;
          callback(err);
        }
      })
    });

    (<any>ret).cancel = () => req.close();
    return ret;
  }

}

